/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resettolistinglocation3Inputs */

const en_resettolistinglocation3 = /** @type {(inputs: Resettolistinglocation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset to listing address`)
};

const de_resettolistinglocation3 = /** @type {(inputs: Resettolistinglocation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Adresse des Orts zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset to listing address" |
*
* @param {Resettolistinglocation3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const resettolistinglocation3 = /** @type {((inputs?: Resettolistinglocation3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resettolistinglocation3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resettolistinglocation3(inputs)
	return de_resettolistinglocation3(inputs)
});
export { resettolistinglocation3 as "resetToListingLocation" }